<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'查看课程下发':'新增课程下发'" :visible.sync="dialog" @close="unShowClick()" width="31%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="选择课程" prop="level" :label-width="formLabelWidth">
					<el-select :disabled='isEdit' style="width: 100%;" v-model="addBody.course_uuid" placeholder="请选择课程"
						@change="changeCourse">
						<el-option v-for="item in courseList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择章节" prop="level" :label-width="formLabelWidth">
					<el-select :disabled='isEdit' style="width: 100%;" multiple v-model="addBody.chapter_uuid" placeholder="请选择章节">
						<el-option v-for="item in chapter" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="下发类型" prop="type" :label-width="formLabelWidth">
					<el-select :disabled='isEdit' style="width: 100%;" v-model="addBody.type" placeholder="请选择下发类型">
						<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择用户" v-if="addBody.type == 1" prop="level" :label-width="formLabelWidth">
					<el-select :disabled='isEdit' style="width: 100%;" multiple v-model="addBody.user_uuid" placeholder="请选择用户">
						<el-option v-for="item in userList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择企业" v-if="addBody.type == 3" prop="level" :label-width="formLabelWidth">
					<el-select :disabled='isEdit' style="width: 100%;" multiple v-model="addBody.business_uuid" placeholder="请选择企业">
						<el-option v-for="item in businessList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" v-if="!isEdit">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCourseList,
		getCourseDetail,
		addSendCourse,
		editUser,
		getUser
	} from '@/api/course'
	import {
		getBusinessList,
		getUserList
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				typeList: [{
						value: 1,
						label: '个人用户'
					},
					{
						value: 2,
						label: '全体用户'
					},
					{
						value: 3,
						label: '企业用户'
					}
				],
				courseList: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					chapter_uuid: [],
					course_uuid: '',
					type: 1,
					user_uuid: [],
					business_uuid: [],
					uuid:''
				},
				images: [],
				roleUuid: "",
				rules: {
					identity: [{
						required: true,
						message: '请选择身份',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					// phone: [{
					// 	required: true,
					// 	message: '请输入手机号',
					// 	trigger: 'blur'
					// }, ],
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				chapter: [],
				businessList:[],
				userList:[]
			}
		},
		mounted() {},
		methods: {
			async getUserList(){
				const {
					status,
					data
				} = await getUserList({
					page_index:1,
					page_size:99999
				});
				if (status !== 200) return;
				this.userList = data.result.data
			},
			async getBusinessList(){
				const {
					status,
					data
				} = await getBusinessList({
					page_index:1,
					page_size:999
				});
				if (status !== 200) return;
				this.businessList = data.result.data
			},
			async changeCourse(e) {
				if(!e) return
				let obj = {
					uuid: e
				}
				const {
					status,
					data
				} = await getCourseDetail(obj);
				if (status !== 200) return;
				this.chapter = data.result.chapter
				this.addBody.chapter_uuid = ''
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addSendCourse()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
				setTimeout(()=>{
					this.isEdit = false
				},300)
			},
			network() {
				return {
					getCourseList: async () => {
						let postData = {
							page_size: 9999,
							page_index: 1,
						};
						const {
							status,
							data
						} = await getCourseList(postData);
						if (status !== 200) return;
						this.courseList = data.result.data;
					},
					addSendCourse: async () => {
						const {
							status,
							data
						} = await addSendCourse({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.network().getCourseList()
				this.getBusinessList()
				this.getUserList()
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.addBody.chapter_uuid = val.chapter_uuid
					this.addBody.course_uuid = val.course_uuid
					this.addBody.type = val.type
					this.addBody.user_uuid = val.user_uuid
					this.addBody.business_uuid = val.business_uuid
					this.addBody.uuid = val.uuid
					this.changeCourse(val.course_uuid)
				} else {
					this.isEdit = false;
					this.addBody.chapter_uuid = []
					this.addBody.course_uuid = ''
					this.addBody.type = 1
					this.addBody.user_uuid = []
					this.addBody.business_uuid = []
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>